import { gql } from "@apollo/client";
export default gql`
  mutation UpdateUserHospitalReports($input: UserHospitalReportsInput!) {
    updateUserHospitalReports(input: $input) {
      error
      message
    }
  }
`;
